import axios from "axios";
import { describeApiError, newRequestId } from "./apiError";
import { notifyApiError } from "./notify";

let installed = false;

// Once, at startup: tag every API call with an X-Request-Id (the server
// adopts it, so client and server logs line up) and tell the user once
// when their session has expired. Everything else is left to call sites.
export default function installApiErrorHandling(client = axios) {
  if (installed) return;
  installed = true;

  client.interceptors.request.use((config) => {
    const url = config.url || "";
    if (url.startsWith("/api/")) {
      config.headers = config.headers || {};
      if (!config.headers["X-Request-Id"]) config.headers["X-Request-Id"] = newRequestId();
    }
    return config;
  });

  client.interceptors.response.use(undefined, (err) => {
    const url = (err && err.config && err.config.url) || "";
    const sentToken = Boolean(err && err.config && err.config.headers && err.config.headers.Authorization);
    if (url.startsWith("/api/") && sentToken && !/\/users\/(login|register)/.test(url)) {
      if (describeApiError(err).kind === "unauthenticated") {
        notifyApiError(err, { toastId: "session-expired" });
      }
    }
    return Promise.reject(err);
  });
}
